import { Box, Tooltip } from "@mui/material";
import { IconTypes } from "../../components/icons.types";
import { Product } from "../../features/products/product";
import { getBundleComposition, isBundle } from "../../features/products/bundle";

interface BundleMarkerProps {
  product: Product | null | undefined;
}

/**
 * Compact in-list marker for bundle products. Renders nothing for non-bundles.
 * Designed to sit BEFORE the product name so long names truncate cleanly without
 * pushing the indicator off the row.
 */
export const BundleMarker = ({ product }: BundleMarkerProps) => {
  if (!isBundle(product)) return null;
  const count = getBundleComposition(product)?.components.length ?? 0;
  return (
    <Tooltip title={`Bundle of ${count} ${count === 1 ? "product" : "products"}`}>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          flexShrink: 0,
          mr: 0.5,
          color: "primary.main",
          verticalAlign: "middle",
          lineHeight: 0,
        }}
      >
        <IconTypes.Bundle sx={{ fontSize: 14 }} />
      </Box>
    </Tooltip>
  );
};
